/**
 * @desc 需求初审-附件列表
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.ResponseDto<defs.basics.ProductConfirmFileResponseDto>;
export function request(pscno: string, options?: any): Promise<Response> {
  return updateResponse(
    http(URL + `/basics/productConfirm/files/${pscno}`, {
      method: "GET",

      ...options,
    }),
  );
}
